import React, { useMemo } from 'react';
import { useEffect, useState } from "react";
import Select from 'react-select';
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { onlyAlphabets, generatePDF, formatDate, getDateCombination, isImageValidPng } from '../../commonClass/CommonValidation'
import Switch from 'react-switch';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ExportExcel } from '../../commonClass/ExportExcel';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import { useNavigate } from 'react-router-dom';
import RichTextBox from '../../../customControl/RichTextBox';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../ImageUpload/ImageCommon';
import CustomTable from '../../../customControl/CustomTable';
import CommonFilter from '../../../customControl/CommonFilter';

const Locationmaster = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formError, setFormError] = useState({})
    const [editorRef, setEditorRef] = useState(null);
    const defaultStateId = 38;

    const [formValue, setFormValue] = useState(
        {
            LocationId: 0,
            ContinentId: 0,
            SubContinentId: 0,
            CountryId: 0,
            RegionId: 0,
            StateId: defaultStateId,
            City: '',
            CityDetail: '',
            PlaceImageName: '',
            PlaceImagePath: '',
            Latitude: '',
            Longitude: '',
            IsActive: false,
        }
    );

    const [modalShow, setModalShow] = useState(false);
    const [locationlistdata, setLocationListData] = useState([]);
    const [filteritems, setFilterItems] = useState([]);
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [disabled, setDisabled] = useState(false);
    const [editdisabled, setEditDisabled] = useState(true);
    const [serchdisable, setSerachDisable] = useState(false);
    const [locationduplicateerrorMessage, setLocationDuplicateErrorMessage] = useState('');
    const [continentData, setContinentData] = useState([]);

    const [countryData, setCountryData] = useState([]);
    const [subcontinentData, setSubcontinentData] = useState([]);

    const [regionData, setRegionData] = useState([]);

    const [stateData, setStateData] = useState([]);
    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');

    const getContinentData = async () => {
        const ContinentData = await getAllData("/master/v1/getlocationcontinent");
        setContinentData(ContinentData?.data?.map(value => ({
            label: value.continentName,
            value: value.continentId
        })));
    }

    const getlocationsubcontinent = async () => {
        const SubcontinentData = await getAllData('/master/v1/getlocationsubcontinent');
        setSubcontinentData(SubcontinentData.data);
    }

    const SubcontinentList = useMemo(() => {
        if (subcontinentData?.length <= 0 || formValue.ContinentId === 0) {
            return [];
        }
        else {
            return subcontinentData?.filter(obj => obj.ContinentId === formValue.ContinentId)?.map(value => ({
                label: value.SubContinentName,
                value: value.SubContinentId
            }));
        }
    }, [formValue.ContinentId, subcontinentData])

    const getCountryData = async () => {
        const CountryData = await getAllData('/master/v1/getlocationcountry');
        setCountryData(CountryData.data);
    }

    const CountryList = useMemo(() => {
        if (countryData?.length <= 0 || formValue.SubContinentId === 0) {
            return [];
        }
        else {
            return countryData?.filter(obj => obj.subContinentId === formValue.SubContinentId)?.map(value => ({
                label: value.countryName,
                value: value.countryId
            }));
        }

    }, [formValue.SubContinentId, countryData])


    countryData?.map(value => ({
        label: value.countryName,
        value: value.countryId
    }));

    const getRegiondata = async () => {
        const Regiondata = await getAllData('/master/v1/getlocationregion');
        setRegionData(Regiondata.data)
    }

    const RegionList = regionData?.map(value => ({
        label: value.regionName,
        value: value.regionId
    }));

    const getStatedata = async () => {
        const Statedata = await getAllData('/master/v1/getlocationstate');
        setStateData(Statedata.data)
    }

    const StateList = useMemo(() => {
        if (stateData?.length <= 0 || formValue.RegionId === 0) {
            return [];
        }
        else {
            return stateData?.filter(obj => obj.regionId === formValue.RegionId)?.map(value => ({
                label: value.stateName,
                value: value.stateId
            }));
        }
    }, [formValue.RegionId, stateData])

    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            getContinentData();
            getCountryData();
            getlocationsubcontinent();
            getRegiondata();
            getStatedata();
            getLocationDataList().then(() => { dispatch(loaderActions?.end()) });
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }, []);

    useEffect(() => {
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });
    }, [user])

    const onSelectChange = (name, e) => {
        setEditDisabled(true);
        setFormError({});
        setLocationDuplicateErrorMessage('');
        if (name === "ContinentId") {
            setFormValue((form) => ({ ...form, ContinentId: e.value, SubContinentId: 0, CountryId: 0, StateId: defaultStateId, RegionId: 0 }))
        }
        else if (name === "SubContinentId") {
            setFormValue((form) => ({ ...form, SubContinentId: e.value, CountryId: 0, StateId: defaultStateId, RegionId: 0 }))
        }
        else if (name === "CountryId") {
            setFormValue((form) => ({ ...form, CountryId: e.value, StateId: defaultStateId, RegionId: 0 }))
        }
        else if (name === "RegionId") {
            setFormValue((form) => ({ ...form, RegionId: e.value, StateId: defaultStateId }))
        }
        else if (name === "StateId") {
            setFormValue((form) => ({ ...form, StateId: e.value }))
        }
        else {
            setFormValue((form) => ({ ...form, [name]: e.value }))
        }
    }

    const validateData = () => {
        let status = true;
        let error = {}
        if (formValue.ContinentId === 0) {
            error["ContinentId"] = 'Please select Continent.';
            status = false;
        }
        if (formValue.ContinentId !== 0 && formValue.SubContinentId === 0) {
            error["SubContinentId"] = 'Please select Sub-Continent.';
            status = false;
        }
        if (formValue.SubContinentId !== 0 && formValue.CountryId === 0) {
            error["CountryId"] = 'Please select Country.';
            status = false;
        }
        if (formValue.CountryId === 1 && formValue.RegionId === 0) {
            error["RegionId"] = 'Please select region.';
            status = false;
        }
        if (formValue.CountryId === 1 && formValue.StateId === defaultStateId && formValue.RegionId !== 0) {
            error["StateId"] = 'Please select State.';
            status = false;
        }
        if (typeof formValue.City === 'string' && formValue.City?.trim()?.length === 0) {
            error["City"] = 'Please enter City name.';
            status = false;
        }
        if (typeof formValue.PlaceImagePath === 'string' && formValue.PlaceImagePath?.trim()?.length === 0) {
            error["CityImage"] = 'Please upload City Image.';
            status = false;
        }
        if (formValue.PlaceImagePath === null || formValue.PlaceImagePath === '') {
            error["CityImage"] = 'Please upload City Image.';
            status = false;
        }
        if (typeof formValue.Latitude === 'string' && formValue.Latitude?.trim()?.length > 0) {
            if (typeof formValue.Longitude === 'string' && formValue.Longitude?.trim()?.length === 0) {
                error["Longitude"] = 'Please enter Longitude.';
                status = false;
            }

        }
        if (typeof formValue.Longitude === 'string' && formValue.Longitude?.trim()?.length > 0) {
            if (typeof formValue.Latitude === 'string' && formValue.Latitude?.trim()?.length === 0) {
                error["Latitude"] = 'Please enter Latitude.';
                status = false;
            }
        }
        if (typeof formValue.CityDetail === 'string' && formValue.CityDetail?.trim()?.length === 0) {
            error["CityDetail"] = 'Please enter City Details.';
            status = false;
        }

        if (error[0] === "ContinentId" || error[0] === "SubContinentId" || error[0] === "CountryId" || error[0] === "RegionId" || error[0] === "StateId") {
            eval(error[0]).current.focus();
        }
        else {
            let doc = document.getElementById(error[0]);
            if (doc !== null)
                doc.focus();
        }
        setFormError(error)
        return status;
    }

    const handleAddClick = async () => {
        if (validateData()) {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let filterdata = locationlistdata?.filter(issec =>
                    issec.locationId !== formValue.LocationId
                    && issec.continentId === formValue.ContinentId
                    && issec.subContinentId === formValue.SubContinentId
                    && issec.countryId === formValue.CountryId
                    && issec.regionId === formValue.RegionId
                    && issec.stateId === formValue.StateId
                    && issec.city?.toLowerCase()?.trim() === formValue.City?.toLowerCase()?.trim()
                );

                if (filterdata?.length > 0) {
                    setLocationDuplicateErrorMessage('You can not enter duplicate value.');
                    return;
                }
                if (statusoftoken) {
                    dispatch(loaderActions.start());
                    formValue.City = formValue.City?.trim(); // trim city name
                    if (buttonaddeditText === "Add") {
                        const LocationData = await postUsersData("/master/v1/insertlocation", formValue);
                        if (!LocationData.status && !LocationData.data) {
                            setLocationDuplicateErrorMessage(LocationData.message);
                            dispatch(loaderActions.end());
                            return;
                        }
                        if (LocationData.status) {
                            if (LocationData.data > 0) {

                                const isImageUpload = await ImageUpload('CMS/Location/', formValue.PlaceImageName, fileselected)
                                if (isImageUpload) {
                                    dispatch(loaderActions.end());
                                    getLocationDataList();
                                    dispatch({ type: 'ALERTING', message: LocationData.message })
                                    clear();
                                }
                                else {
                                    dispatch(loaderActions.end());
                                    dispatch({ type: 'ALERTING', message: 'Try again later!' })
                                    setDisabled(false);
                                    setEditDisabled(true);
                                }
                            }
                            else {
                                dispatch({ type: 'ALERTING', message: LocationData.message })
                                dispatch(loaderActions.end());
                            }
                        }
                        else {
                            dispatch({ type: 'ALERTING', message: LocationData.message })
                            dispatch(loaderActions.end());
                        }
                    }
                    else {
                        const LocationData = await patchUsersData("/master/v1/updatelocation", formValue);
                        if (!LocationData.status && !LocationData.data) {
                            setLocationDuplicateErrorMessage(LocationData.message);
                            dispatch(loaderActions.end());
                            return;
                        }

                        if (LocationData.status) {
                            if (LocationData.data > 0) {
                                if (placeimagepath.length === 0) {
                                    const isImageUpload = await ImageUpload('CMS/Location/', formValue.PlaceImageName, fileselected)
                                    if (isImageUpload) {
                                        const isImageDelete = await ImageDelete(placeimagedelete)
                                        if (!isImageDelete) {
                                            dispatch(loaderActions.end());
                                            dispatch({ type: 'ALERTING', message: 'Image delete transaction failed' })
                                            setDisabled(false);
                                            setEditDisabled(true);
                                            return;
                                        }

                                        dispatch(loaderActions.end());
                                        getLocationDataList();
                                        dispatch({ type: 'ALERTING', message: LocationData.message })
                                        clear();
                                    }
                                    else {
                                        dispatch(loaderActions.end());
                                        dispatch({ type: 'ALERTING', message: 'Image save transaction faild!' })
                                        setDisabled(false);
                                        setEditDisabled(true);
                                        return;
                                    }
                                }
                                else {
                                    dispatch(loaderActions.end());
                                    getLocationDataList();
                                    dispatch({ type: 'ALERTING', message: LocationData.message })
                                    clear();
                                }
                            }
                            else {
                                dispatch({ type: 'ALERTING', message: LocationData.message })
                                dispatch(loaderActions.end());
                                return;
                            }
                        }
                        else {
                            dispatch({ type: 'ALERTING', message: LocationData.message })
                            dispatch(loaderActions.end());
                        }
                    }
                    dispatch(loaderActions.end());
                }
                else {
                    ClearLocalStorage();
                    dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
    }

    const handleEditMode = (id) => {
        setDisabled(false);
        setEditDisabled(false);
        setSerachDisable(true);
        setButtonAddEditText("Update");
        RetriveData(id);
    }

    const handleViewMode = (id) => {
        setEditDisabled(false);
        setDisabled(true);
        setSerachDisable(true);
        RetriveData(id);
    }

    function RetriveData(id) {
        setFormError({});
        setLocationDuplicateErrorMessage('');
        locationlistdata?.map(obj => {
            if (obj.locationId === id) {
                setFormValue((form) => ({
                    ...form,
                    ContinentId: obj.continentId,
                    SubContinentId: subcontinentData?.filter(el => el.ContinentId === obj.continentId && el.SubContinentId === obj.subContinentId)?.length > 0 ? obj.subContinentId : 0,
                    CountryId: countryData?.filter(el => el.subContinentId === obj.subContinentId && el.countryId === obj.countryId)?.length > 0 ? obj.countryId : 0,
                    RegionId: obj.countryId === 1 ? obj.regionId : 0,
                    StateId: obj.stateId,
                    LocationId: obj.locationId,
                    City: obj.city,
                    Latitude: obj.latitude,
                    Longitude: obj.longitude,
                    IsActive: obj.isActive,
                    CityDetail: obj.cityDetail != null ? obj.cityDetail : '',
                    PlaceImageName: obj.placeImageName,
                    PlaceImagePath: obj.placeImagePath
                }))
                setPlaceImagePath(CommonFileURLWithFolder + obj.placeImagePath);
                setPlaceImageName(obj.placeImageName);
                setplaceimageDelete(obj.placeImagePath);
            }
        });
    }

    const getLocationDataList = async () => {
        const LocationListData = await getAllData("/master/v1/getalllocation");
        LocationListData?.data?.map((obj) => {
            obj.IsActiveFormat = obj?.isActive ? 'Active' : 'InActive';
            obj.CreatedDateFormat = formatDate(obj?.createdDate);
            return obj;
        })
        setLocationListData(LocationListData?.data);
        setFilterItems(LocationListData?.data)
    }

    const [richboxheight, setRichBoxHeight] = useState(false)
    const citydetailconfig = useMemo(
        () => ({
            readonly: false, // all options from https://xdsoft.net/jodit/doc/,
            height: '100%',
            maxHeight: richboxheight === true ? 200 : 500,
            width: '100%',
            statusbar: false,
            disablePlugins: ["source"],
            removeButtons: ["about", "link"],
            toolbarAdaptive: false,
            defaultMode: "1",
            disabled: disabled ? true : false
        }),
        [disabled, richboxheight]
    );

    useEffect(() => {
        const richtexteboxheight = document.getElementById("layoutSidenav_content").clientWidth
        if (richtexteboxheight > 1253) {
            setRichBoxHeight(true)
        }
        else {
            setRichBoxHeight(false)
        }
    }, []);

    const [placeimagedelete, setplaceimageDelete] = useState('');
    const [placeimagepath, setPlaceImagePath] = useState('');
    const [placeimagename, setPlaceImageName] = useState();
    const [fileselected, setSelectedFile] = useState();

    const handleUploadImageLoad = (e) => {
        let error = {}
        if (isImageValidPng(e.target.files[0].name)) {
            const files = e.target.files;
            const filename = getDateCombination(files[0].name);
            formValue.PlaceImageName = filename
            formValue.PlaceImagePath = 'CMS/Location/' + filename
            setSelectedFile(e.target.files[0]);
            setEditDisabled(true);
            setFormError({});
            setLocationDuplicateErrorMessage('');
            setPlaceImagePath('');
            setPlaceImageName('');
        }
        else {
            document.getElementById("CityImage").value = "";
            setFormValue({ ...formValue, PlaceImageName: '', PlaceImagePath: '' });
            setEditDisabled(true);
            setLocationDuplicateErrorMessage('');
            error.CityImage = "Only PNG file type is accepted.";
            setFormError(error);
            setPlaceImagePath('');
            setPlaceImageName('');
            return;
        }
    }

    const removeImage = () => {
        document.getElementById("CityImage").value = "";
        formValue.PlaceImagePath = ''
        formValue.PlaceImageName = ''
        setSelectedFile();
        setEditDisabled(true);
        setPlaceImagePath('');
        setPlaceImageName('');
        setFormError({});
        setLocationDuplicateErrorMessage('');
    };

    const onChange = (e) => {
        var result;
        if ([e.target.name][0] === 'City') {
            result = onlyAlphabets(e.target.value)
        }
        else {
            result = e.target.value
        }
        setFormValue({ ...formValue, [e.target.name]: result });
        setEditDisabled(true);
        setFormError({});
        setLocationDuplicateErrorMessage('');
    }

    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            formValue.IsActive = e
            setFormError({});
            setLocationDuplicateErrorMessage('');
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            formValue.IsActive = !formValue?.IsActive
            setEditDisabled(true);
            setFormError({});
            setLocationDuplicateErrorMessage('');
        }
        setModalShow(false);
    }

    const clear = () => {
        setFormError({});
        setLocationDuplicateErrorMessage('');
        setFormValue((form) => ({
            ...form,
            LocationId: 0,
            ContinentId: 0,
            SubContinentId: 0,
            CountryId: 0,
            RegionId: 0,
            StateId: defaultStateId,
            City: '',
            CityDetail: '',
            PlaceImageName: '',
            PlaceImagePath: '',
            Latitude: '',
            Longitude: '',
            IsActive: false,
        }))
        getLocationDataList();
        setButtonAddEditText('Add');
        setDisabled(false);
        setEditDisabled(true);
        setSerachDisable(false);
        setSerachBy('All');
        setSearchValue('');
        document.getElementById("CityImage").value = "";
        setSelectedFile();
        setPlaceImagePath('')
        setPlaceImageName('');
        setplaceimageDelete('');
        if (editorRef?.current) {
            editorRef.current.value = ''; // clear the content
        }
        if (document.querySelector('.jodit-wysiwyg') !== null) {
            document.querySelector('.jodit-wysiwyg').innerHTML = '';
        }
    }

    const columns = [
        {
            name: 'Continent',
            key: "continentName",
            sortable: true,
            float: "left",
            selector: (location) => location?.continentName,
        },
        {
            name: 'Sub continent',
            key: "subContinentName",
            sortable: true,
            float: "left",
            selector: (location) => location?.subContinentName,
        },
        {
            name: 'Country',
            key: "countryName",
            sortable: true,
            float: "left",
            selector: (location) => location?.countryName
        },
        {
            name: 'Region',
            key: "regionName",
            sortable: true,
            float: "left",
            selector: (location) => location?.regionName
        },
        {
            name: 'State',
            key: "stateName",
            sortable: true,
            float: "left",
            selector: (location) => location?.stateName
        },
        {
            name: 'City',
            key: "city",
            sortable: true,
            float: "left",
            selector: (location) => location?.city
        },
        {
            name: 'Latitude',
            key: "latitude",
            sortable: true,
            float: "left",
            selector: (location) => location?.latitude
        },
        {
            name: 'Longitude',
            key: "longitude",
            sortable: true,
            float: "left",
            selector: (location) => location?.longitude
        },
        {
            name: 'Active',
            key: "IsActiveFormat",
            sortable: true,
            float: "left",
            selector: (location) => location?.IsActiveFormat
        },
        {
            name: 'Created Date',
            key: "CreatedDateFormat",
            sortable: true,
            float: "left",
            selector: (location) => new Date(location?.createdDate),
            format: (location) => location?.CreatedDateFormat,
        },
        {
            name: 'Edit',
            selector: (location) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditMode(location.locationId)}></i></button>
        },
        {
            name: 'View',
            selector: (location) => <i className="fa fa-eye" onClick={() => handleViewMode(location.locationId)}></i>
        }
    ];

    //#region PDF and Excel Export
    const PdfExport = () => {
        const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const rows = locationlistdata?.map((obj) => keys?.map((key) => obj[key]));
        generatePDF(pdfColumns, rows, "LocationMaster", "Location Master");
    }
    const ExportToExcel = () => {
        const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        ExportExcel(dispalyname, fields, locationlistdata, "LocationMaster", "LocationMaster.xls");
    }
    //#endregion

    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>Location Master</h3>
            </div>
            <div className="container-fluid form_border py-5 mb-3">
                <form action="" >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12 pe-lg-5">
                            <div className="row">
                                {locationduplicateerrorMessage && <div className="text-danger pb-3 text-center"> {locationduplicateerrorMessage} </div>}
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label htmlFor="ContinentId" className="ms-lg-5 col-form-label required" >
                                                Continent</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <Select
                                                id='ContinentId'
                                                className="dropdown select_dropdown"
                                                options={continentData}
                                                value={continentData?.filter((continentList) => {
                                                    return continentList.value === formValue?.ContinentId;
                                                })}// set list of the data
                                                onChange={(e) => onSelectChange("ContinentId", e)} // assign onChange function
                                                isDisabled={disabled ? true : false}
                                                isSearchable={true}

                                            />
                                            {formError?.ContinentId && <p className="text-danger mb-0"> {formError?.ContinentId} </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label htmlFor="SubContinentId" className="ms-lg-5 col-form-label required" >
                                                Sub continent</label>
                                        </div>
                                        <div className=" col-lg-8 mb-1 col-md-12">
                                            <Select
                                                id='SubContinentId'
                                                className="dropdown select_dropdown"
                                                options={SubcontinentList}
                                                value={SubcontinentList?.filter((data) => {
                                                    return data.value === formValue.SubContinentId;
                                                })}// set list of the data
                                                onChange={(e) => onSelectChange("SubContinentId", e)} // assign onChange function
                                                isDisabled={disabled || formValue.ContinentId === 0 ? true : false}
                                                isSearchable={true}
                                            />
                                            {formError?.SubContinentId && <p className="text-danger mb-0"> {formError?.SubContinentId} </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label htmlFor="CountryId" className="ms-lg-5 col-form-label required">Country</label>
                                        </div>
                                        <div className=" col-lg-8 mb-1 col-md-12">
                                            <Select
                                                id='CountryId'
                                                className="dropdown select_dropdown"
                                                options={CountryList}
                                                value={CountryList?.filter((CountryList) => {
                                                    return CountryList.value === formValue.CountryId;
                                                })}// set list of the data
                                                onChange={(e) => onSelectChange("CountryId", e)}  // assign onChange function
                                                isDisabled={disabled || formValue.SubContinentId === 0 ? true : false}
                                                isSearchable={true}
                                            />
                                            {formError?.CountryId && <p className="text-danger mb-0"> {formError?.CountryId} </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label htmlFor="RegionId" className={`ms-lg-5 col-form-label ${formValue.CountryId === 1 ? 'required' : ''} `}>Region</label>
                                        </div>
                                        <div className=" col-lg-8 mb-1 col-md-12">
                                            <Select
                                                id="RegionId"
                                                className="dropdown select_dropdown"
                                                options={RegionList}
                                                value={RegionList?.filter((RegionList) => {
                                                    return RegionList.value === formValue.RegionId;
                                                })}// set list of the data
                                                onChange={(e) => onSelectChange("RegionId", e)}  // assign onChange function
                                                isDisabled={disabled || formValue.CountryId !== 1 || formValue.CountryId === 0 ? true : false}
                                                isSearchable={true}

                                            />
                                            {formError?.RegionId && <p className="text-danger mb-0"> {formError?.RegionId} </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label htmlFor="StateId" className={`ms-lg-5 col-form-label ${formValue.CountryId === 1 ? 'required' : ''} `} >State</label>
                                        </div>
                                        <div className=" col-lg-8 mb-1 col-md-12">
                                            <Select
                                                id='StateId'
                                                className="dropdown select_dropdown"
                                                options={StateList}
                                                value={StateList?.filter((StateList) => {
                                                    return StateList.value === formValue.StateId;
                                                })}// set list of the data
                                                onChange={(e) => onSelectChange("StateId", e)} // assign onChange function
                                                isDisabled={disabled || formValue.CountryId === 0 || formValue.CountryId !== 1 || formValue.RegionId === 0 ? true : false}
                                                isSearchable={true}
                                            />
                                            {formError?.StateId && <p className="text-danger mb-0"> {formError?.StateId} </p>}
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label htmlFor="City" className="ms-lg-5 col-form-label required">City</label>
                                        </div>
                                        <div className=" col-lg-8 mb-1 col-md-12">
                                            <input type="text"
                                                id="City"
                                                placeholder="City"
                                                className="form-control"
                                                name="City"
                                                value={formValue.City}
                                                onChange={onChange}
                                                disabled={disabled} />
                                            {formError?.City && <p className="text-danger mb-0"> {formError?.City} </p>}
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-6 col-sm-6'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label htmlFor="inputPassword6" className="ms-lg-5 col-form-label required">Upload City Image</label>
                                        </div>
                                        <div className="col-lg-8 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                            <div className="input-group">
                                                <input
                                                    name='CityImage'
                                                    type="file"
                                                    id="CityImage"
                                                    onChange={handleUploadImageLoad}
                                                    className="form-control btn_add"
                                                    accept=".png"
                                                    disabled={disabled ? true : false}
                                                />
                                                <label className="input-group-text" htmlFor="CityImage">Browse</label>
                                            </div>
                                            {formError?.CityImage && <p className="text-danger mb-0"> {formError?.CityImage} </p>}
                                            {placeimagename && <p className='text-start overflow-hidden' data-bs-toggle="tooltip" data-bs-placement="left" title={placeimagename}>
                                                {placeimagename}</p>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 pe-lg-5">
                            <div className="row">
                                <div className='col-lg-6 col-sm-6'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label htmlFor="inputPassword6" className="ms-lg-5 col-form-label">Latitude</label>
                                        </div>
                                        <div className=" col-lg-8 mb-1 col-md-12">
                                            <input type="text" id="Latitude" placeholder="Latitude" className="form-control" name="Latitude" value={formValue.Latitude} onChange={onChange} disabled={disabled} />
                                            {formError?.Latitude && <p className="text-danger mb-0"> {formError?.Latitude} </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label htmlFor="inputPassword6" className="ms-lg-5 col-form-label">Longitude</label>
                                        </div>
                                        <div className=" col-lg-8 mb-1 col-md-12">
                                            <input type="text" id="Longitude" placeholder="Longitude" className="form-control" name="Longitude" value={formValue.Longitude} onChange={onChange} disabled={disabled} />
                                            {formError?.Longitude && <p className="text-danger mb-0"> {formError?.Longitude} </p>}
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-12 col-sm-12 '>
                                    <div className="row">
                                        <div className="col-lg-2 col-md-12 mb-1">
                                            <label htmlFor="CityDetail" className="ms-lg-5 col-form-label required">City Details</label>
                                        </div>
                                        <div className="col-lg-10 mb-1 col-md-12">
                                            <RichTextBox
                                                setRef={setEditorRef}
                                                field="CityDetail"
                                                fieldvalue={formValue.CityDetail}
                                                tabIndex={1}
                                                OnChangeofRichBox={(value) => { formValue.CityDetail = value; setEditDisabled(true) }}
                                                textconfig={citydetailconfig}
                                            />
                                            {formError?.CityDetail && <p className="text-danger mb-0"> {formError?.CityDetail} </p>}
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label htmlFor="inputPassword6" className="ms-lg-5 col-form-label">Active</label>
                                        </div>
                                        <div className="col-auto col-lg-2 col-md-7 col-sm-12">
                                            <Switch
                                                onChange={handleisActive}
                                                checked={formValue?.IsActive}
                                                className="react-switch"
                                                disabled={disabled}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            {fileselected &&
                                (
                                    <div className="col-lg-2 col-md-3 col-6 mx-auto mt-2">
                                        <img
                                            src={URL.createObjectURL(fileselected)} className="img-fluid w-100" alt=''
                                        />
                                        <button onClick={() => removeImage()} type="button" data-close style={{ objectposition: "right top;", position: "absolute", fontSize: "36px", background: 'none', border: 'none' }} disabled={disabled ? true : false} >&times;</button>
                                    </div>
                                )}
                            {(!fileselected && placeimagepath !== `${CommonFileURLWithFolder}null` && placeimagepath !== CommonFileURLWithFolder && placeimagepath?.trim()?.length > 0) && (
                                <div className="col-lg-2 col-md-3 col-6 mx-auto mt-2" >
                                    <img
                                        src={placeimagepath} className="img-fluid w-100" alt=''
                                    />
                                    <button onClick={() => removeImage()} type="button" data-close style={{ objectposition: "right top;", position: "absolute", fontSize: "36px", background: 'none', border: 'none' }} disabled={disabled ? true : false} >&times;</button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className=" d-flex justify-content-center mb-4">
                        {useradd === false && buttonaddeditText === "Add" ?
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={!useradd}>{buttonaddeditText}</button> :
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                        <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={clear}  >Clear</button>
                    </div>

                    <CommonFilter
                        columns={columns}
                        filterList={filteritems}
                        searchDisabled={serchdisable}
                        getdata={getLocationDataList}
                        setlistdata={setLocationListData}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={locationlistdata}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />

                </form>
            </div>
        </>
    )
}

export default Locationmaster;